@if (isLoading) {
  <div class='sideBarContent content loading-spinner'></div>
}
@if (!isLoading) {
  <div class="sideBarContent content">
    <irb-editor-sidebar-banner
      [accordian]="accordion"
      [showUnsavedChangesWarning]="showUnsavedChangesWarning"
      [isModified]="isModified"
      [isValid]="isValid"
      [hasPendingFunction]="hasPendingFunction"
      [slot]="slot"
      (save)="save()"
      (cancel)="cancel()"><span header class="ms-header" tooltip [tooltipTitle]="'Edit Multiple Security'" [tooltipRequiresTruncation]="true">Edit Multiple Security</span></irb-editor-sidebar-banner>
      <div [style.height]="bodyHeight" #body class="edit-security-container-page body">
        <div class="block editorDisplayBanner">
          <div class="left" style="display:flex">
            <div class="editorDispalybannerHeader edit-security-symbol-container" style="min-width: 100px">
              <div class="editorDispalybannerText">
                <p #securitySymbol >Symbol</p>
              </div>
              <span class="editorDispalyValueText security-symbol-truncate"
                tooltip
                [tooltipTitle]="symbol"
                [tooltipRequiresTruncation]="true"
                tooltipPosition="bottom">
                {{symbol}}
              </span>
            </div>
            <div class="editorDispalybannerHeader"
              style="min-width: 200px;word-break: break-word;white-space: normal;">
              <div class="editorDispalybannerText">
                <p #securityDescription>Description</p>
              </div>
              <span class="editorDispalyValueText security-description-truncate"
                tooltip
                [tooltipTitle]="symbolDescription"
                [tooltipRequiresTruncation]="true"
                tooltipPosition="bottom">
                {{symbolDescription}}
              </span>
            </div>
          </div>
          <div class="right" style="display:flex">
            <div class="editorDispalybannerHeader"  style="width: 150px;">
              <div class="editorDispalybannerText"><p #lastEdit>Date Last Edited / By</p></div>
              <span class="editorDispalyValueText">{{modifiedDate ==='Various'? modifiedDate: (modifiedDate | easternTime | date:'MM/dd/yyyy h:mm a')}} ET</span>
            </div>
            <div class="editorDispalybannerHeader"  style="width: 75px;">
              <div  class="editorDispalybannerText"><p #securityType>Type</p></div>
              <span class="editorDispalyValueText">{{securityTypeDesc}}</span>
            </div>
          </div>
          <br class="clear"/>
        </div>
        <mat-accordion #accordion="matAccordion" [multi]="true">
          <mat-expansion-panel id="ASSET_CATEGORY"
            [expanded]="ies.getDefaultExpansionState('ASSET_CATEGORY')"
            (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('ASSET_CATEGORY','opened') : ies.updateExpansionState('ASSET_CATEGORY','opened')"
            (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('ASSET_CATEGORY','closed') : ies.updateExpansionState('ASSET_CATEGORY','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Asset Category
              </mat-panel-title>
            </mat-expansion-panel-header>
            <irb-security-asset-category [securityAssetCategoryData]="_tradingMinimumData"
              (categoryChanged)="onCustomAssetCategoryChanged($event)"
            #assetCategoryComponent></irb-security-asset-category>
          </mat-expansion-panel>
          <mat-expansion-panel id="TRADING_MINIMUMS"
            [expanded]="ies.getDefaultExpansionState('TRADING_MINIMUMS')"
            (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('TRADING_MINIMUMS','opened') : ies.updateExpansionState('TRADING_MINIMUMS','opened')"
            (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('TRADING_MINIMUMS','closed') : ies.updateExpansionState('TRADING_MINIMUMS','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Trading Minimums
              </mat-panel-title>
            </mat-expansion-panel-header>
            <irb-trading-minimums [tradingMinimumData]="_tradingMinimumData"
              (dollarPercentChanged)="onTradingMinimumsChanged($event)"
              (alternateSecurityChanged)="onTradingMinimumAlternateSecurityChanged($event)"
            #tradingMinimumsComponent></irb-trading-minimums>
          </mat-expansion-panel>
          <mat-expansion-panel id="PENALTIES"
            [expanded]="ies.getDefaultExpansionState('PENALTIES')"
            (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('PENALTIES','opened') : ies.updateExpansionState('PENALTIES','opened')"
            (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('PENALTIES','closed') : ies.updateExpansionState('PENALTIES','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Penalties
              </mat-panel-title>
            </mat-expansion-panel-header>
            <irb-security-penaltybar [penaltyBarData]="_tradingMinimumData"
            #securityPenaltybarComponent></irb-security-penaltybar>
          </mat-expansion-panel>
          <mat-expansion-panel id="RESTRICTIONS"
            [expanded]="ies.getDefaultExpansionState('RESTRICTIONS')"
            (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('RESTRICTIONS','opened') : ies.updateExpansionState('RESTRICTIONS','opened')"
            (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('RESTRICTIONS','closed') : ies.updateExpansionState('RESTRICTIONS','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Restrictions
              </mat-panel-title>
            </mat-expansion-panel-header>
            <irb-security-restrictions [securityRestrictionsData]="_tradingMinimumData" (restrictionChanged)="onSecurityRestrictionChanged($event)"
            #securityRestrictionsComponent></irb-security-restrictions>
          </mat-expansion-panel>
          <mat-expansion-panel id="EQUIVALENTS_ALTERNATIVES"
            [expanded]="ies.getDefaultExpansionState('EQUIVALENTS_ALTERNATIVES')"
            (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('EQUIVALENTS_ALTERNATIVES','opened') : ies.updateExpansionState('EQUIVALENTS_ALTERNATIVES','opened')"
            (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('EQUIVALENTS_ALTERNATIVES','closed') : ies.updateExpansionState('EQUIVALENTS_ALTERNATIVES','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Equivalents & Alternatives
              </mat-panel-title>
            </mat-expansion-panel-header>
            <irb-security-equivalents-alternatives [securityEquivalentsAlternativesData]="_tradingMinimumData"
              (securityEquivalentsAlternativeChanged)="onSecurityEquivalentsAlternativeChanged($event)"
              #securityEquivalentsAlternativesComponent
            ></irb-security-equivalents-alternatives>
          </mat-expansion-panel>
          @if (isTlhWsaEnabled) {
            <mat-expansion-panel id="TLH_WASH_SALE_ALTERNATIVES"
              [expanded]="ies.getDefaultExpansionState('TLH_WASH_SALE_ALTERNATIVES')"
              (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('TLH_WASH_SALE_ALTERNATIVES','opened') : ies.updateExpansionState('TLH_WASH_SALE_ALTERNATIVES','opened')"
              (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('TLH_WASH_SALE_ALTERNATIVES','closed') : ies.updateExpansionState('TLH_WASH_SALE_ALTERNATIVES','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Tax Loss Harvesting and Wash Sale Alternates
                </mat-panel-title>
              </mat-expansion-panel-header>
              <irb-tlh-wash-sale-alternatives [securityTLHData]="_tradingMinimumData"
                (securityTLHWashSaleEquivalentsChanged)="onSecurityTLHWashSaleEquivalentsChanged($event)"
              #tLHWashSaleAlternativesComponent></irb-tlh-wash-sale-alternatives>
            </mat-expansion-panel>
          }
          <mat-expansion-panel id="HOUSEHOLD_LOCATION_PREFERENCES"
            [expanded]="ies.getDefaultExpansionState('HOUSEHOLD_LOCATION_PREFERENCES')"
            (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('HOUSEHOLD_LOCATION_PREFERENCES','opened') : ies.updateExpansionState('HOUSEHOLD_LOCATION_PREFERENCES','opened')"
            (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('HOUSEHOLD_LOCATION_PREFERENCES','closed') : ies.updateExpansionState('HOUSEHOLD_LOCATION_PREFERENCES','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Household Location Preferences
              </mat-panel-title>
            </mat-expansion-panel-header>
            <irb-household-location-preferences
              [householdLocationPreferencesData]="_tradingMinimumData"
              (rothLevelChanged)="onRothLevelChanged($event)"
              (levelChanged)="onLevelChanged($event)"
              #householdLocationPreferencesComponent>
            </irb-household-location-preferences>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  }
